<div class="dialog">
  <div class="dialog-header">
    <h2>{{ isEditMode ? 'Настройки кассы' : 'Новая касса' }}</h2>
    <p>Заполните реквизиты кассы и данные, которые должны печататься на фискальном чеке.</p>
  </div>

  <form class="dialog-form" [formGroup]="form" (ngSubmit)="save()">
    <div class="section">
      <h3>Основное</h3>

      <mat-form-field appearance="outline">
        <mat-label>Название кассы</mat-label>
        <input matInput formControlName="name" />
        <mat-error *ngIf="form.controls.name.invalid">Укажите название кассы</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Адрес / endpoint кассы</mat-label>
        <input matInput formControlName="address" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>ФН ПРРО</mat-label>
        <input matInput formControlName="prroFiscalNumber" />
      </mat-form-field>
    </div>

    <div class="section">
      <h3>Реквизиты для печати</h3>

      <mat-form-field appearance="outline">
        <mat-label>ФОП / название СХ</mat-label>
        <input matInput formControlName="sellerDisplayName" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Название торговой точки</mat-label>
        <input matInput formControlName="unitDisplayName" />
      </mat-form-field>

      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Подпись идентификатора</mat-label>
          <input matInput formControlName="displayTaxIdLabel" placeholder="ІД / ЄДРПОУ / ІПН" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Значение идентификатора</mat-label>
          <input matInput formControlName="displayTaxIdValue" />
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline">
        <mat-label>Полный адрес для чека</mat-label>
        <textarea matInput rows="3" formControlName="fullAddress"></textarea>
      </mat-form-field>

      <div class="row">
        <mat-checkbox formControlName="printStaticTaxLine">Печатать статическую налоговую строку</mat-checkbox>
      </div>

      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Налоговая подпись</mat-label>
          <input matInput formControlName="staticTaxLabel" placeholder="Без ПДВ" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Буква налоговой группы</mat-label>
          <input matInput formControlName="staticTaxLetter" placeholder="Б" />
        </mat-form-field>
      </div>
    </div>

    <div class="section toggles">
      <mat-checkbox formControlName="isTestMode">Тестовый режим</mat-checkbox>
      <mat-checkbox formControlName="printLogoOnFiscalReceipt">Печатать логотип на фискальном чеке</mat-checkbox>
    </div>

    <div class="actions">
      <button mat-button type="button" [disabled]="saving" (click)="dialogRef.close()">Отмена</button>
      <button mat-flat-button color="primary" type="submit" [disabled]="saving">
        {{ isEditMode ? 'Сохранить' : 'Создать' }}
      </button>
    </div>
  </form>
</div>
